import * as React from 'react';
import { Table, Text, createStyles } from '@mantine/core';
import { useTranslation } from 'react-i18next';

// Types
import { ISalaryRange } from '../../../../../types';

// Local Components
import { WageRangeLabel } from './WageRangeLabel';

const useStyles = createStyles((theme) => ({
    table: {
        border: `1px solid ${theme.colors.gray[3]}`
    },
    centerCell: {
        textAlign: 'center'
    },
    muted: {
        color: theme.colors.gray[4]
    }
}));

interface IWageRangerSummaryProps {
    data: ISalaryRange[];
}

export const WageRangerSummary: React.FC<IWageRangerSummaryProps> = ({ data = [] }) => {
    const { classes, cx } = useStyles();
    const { t } = useTranslation('components');

    return (
        <Table striped highlightOnHover className={classes.table} mt="md">
            <thead>
                <tr>
                    <th>{t('wageRanger.title')}</th>
                    <th style={{ textAlign: 'center' }}>{t('wageRanger.total')}</th>
                    <th style={{ textAlign: 'center' }}>{t('wageRanger.fullPart')}</th>
                </tr>
            </thead>
            <tbody>
                {data.map(({ total = 0, ft = 0, pt = 0, meta }, index) => (
                    <tr key={index}>
                        <td>
                            <Text size="sm">
                                <WageRangeLabel meta={meta} />
                            </Text>
                        </td>
                        <td
                            className={cx(classes.centerCell, {
                                [classes.muted]: !total && !ft && !pt
                            })}
                        >
                            {total}
                        </td>
                        <td
                            className={cx(classes.centerCell, {
                                [classes.muted]: !total && !ft && !pt
                            })}
                        >
                            {ft} / {pt}
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};
